"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));

var _styles = require("@mui/material/styles");

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GapTooltip = function GapTooltip(_ref) {
  var selected = _ref.selected,
      title = _ref.title,
      left = _ref.left,
      top = _ref.top;
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: title,
    placement: "bottom",
    open: !!selected,
    componentsProps: {
      popper: {
        sx: {
          'z-index': 100
        }
      },
      tooltip: {
        sx: _defineProperty({
          color: 'white',
          fontSize: '12px'
        }, theme.breakpoints.down('sm'), {
          fontSize: '10px'
        })
      }
    },
    sx: {
      visibility: selected ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      left: left,
      top: top
    }
  }));
};

var GapTooltips = function GapTooltips(_ref2) {
  var _selected$gap;

  var selected = _ref2.selected,
      onLoad = _ref2.onLoad,
      gapTooltips = _ref2.gapTooltips,
      respondentLabel = _ref2.respondentLabel;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selected && !onLoad && /*#__PURE__*/_react.default.createElement(GapTooltip, {
    selected: selected,
    title: selected ? t('x_gap', {
      gap: "".concat(selected === null || selected === void 0 ? void 0 : (_selected$gap = selected.gap) === null || _selected$gap === void 0 ? void 0 : _selected$gap.diff, "%")
    }) : '',
    left: gapTooltips === null || gapTooltips === void 0 ? void 0 : gapTooltips.midpoint.x,
    top: gapTooltips === null || gapTooltips === void 0 ? void 0 : gapTooltips.midpoint.y
  }));
};

var _default = GapTooltips;
exports.default = _default;